import './default-theme.css'
import './base.css'
import './custom.css'

// Import additional theme CSS files here
import './example-theme.css'

export function applyThemeClass(key: string): void {
  const html = document.documentElement

  html.classList.forEach(cls => {
    if (cls.startsWith('theme-')) {
      html.classList.remove(cls)
    }
  })

  if (key !== 'default') {
    html.classList.add(`theme-${key}`)
  }
}
